<template>
    <v-card class="mx-auto overflow-auto border-radius0" elevation="0" height="90%">
        <v-card-title class="card-header text-left fixed-card-title2">
            <v-row>
                <v-col cols="10">
                    <v-toolbar-title>{{ $t('addMedicalInstitutionTooltip') }}</v-toolbar-title>
                </v-col>
                <v-spacer></v-spacer>
                <v-icon @click="closeDrawer" class="white-icon mr-3">mdi-close</v-icon>
            </v-row>
        </v-card-title>
        <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
                <!-- Data -->
                <v-container>
                    <v-row>
                        <!-- Organization -->
                        <v-col class="d-flex pa-1" cols="12" sm="12">
                            <div class="pt-2">
                                <h5 class="heading text-left">{{ this.$t('Organization') }}</h5>
                            </div>
                        </v-col>
                        <!-- Institution name -->
                        <v-col class="d-flex pa-1" cols="12" sm="12">
                            <v-text-field outlined hide-details="auto" dense
                                v-model="medicalInstitutionToAdd.institutionName"
                                :rules="[v => !!v || 'Item is required']" :label="$t('organization-name')" required
                                :key="'textField1' + componentKey">
                            </v-text-field>
                        </v-col>
                        <!-- Description -->
                        <v-col class="d-flex pa-1" cols="12" sm="12">
                            <v-textarea no-resize outlined hide-details dense
                                v-model="medicalInstitutionToAdd.description" :label="$t('description')"
                                :key="'textArea' + componentKey">
                            </v-textarea>
                        </v-col>
                        <!-- Address label -->
                        <v-col class="d-flex pa-1" cols="12" sm="12">
                            <div class="pt-4">
                                <h5 class="heading text-left">{{ this.$t('address') }}</h5>
                            </div>
                        </v-col>
                        <!-- Address -->
                        <v-col class="d-flex pa-1" cols="12" sm="12">
                            <v-text-field outlined hide-details="auto" dense v-model="medicalInstitutionToAdd.address"
                                :rules="[v => !!v || 'Item is required']" :label="$t('address')" required
                                :key="'textField2' + componentKey">

                            </v-text-field>
                        </v-col>
                        <!-- City -->
                        <v-col class="d-flex pa-1" cols="6" sm="6">
                            <v-text-field outlined hide-details="auto" dense v-model="medicalInstitutionToAdd.city"
                                :rules="[v => !!v || 'Item is required']" :label="$t('city')" required
                                :key="'textField3' + componentKey" disabled>
                            </v-text-field>
                        </v-col>
                        <!-- State -->
                        <v-col class="d-flex pa-1" cols="6" sm="6">
                            <v-text-field outlined hide-details="auto" dense v-model="medicalInstitutionToAdd.state"
                                :rules="[v => !!v || 'Item is required']" :label="$t('state')" required
                                :key="'textField4' + componentKey" disabled>
                            </v-text-field>
                        </v-col>
                        <!-- Zip -->
                        <v-col class="d-flex pa-1" cols="6" sm="6">
                            <v-text-field outlined hide-details="auto" dense v-model="medicalInstitutionToAdd.zip"
                                :rules="[v => !!v || 'Item is required']" :label="$t('zip')" required
                                :key="'textField5' + componentKey" disabled>
                            </v-text-field>
                        </v-col>
                        <!-- Country -->
                        <v-col class="d-flex pa-1" cols="6" sm="6">
                            <v-text-field outlined hide-details="auto" dense v-model="medicalInstitutionToAdd.country"
                                :rules="[v => !!v || 'Item is required']" :label="$t('country')" required
                                :key="'textField6' + componentKey" disabled>
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <!-- Contact label -->
                        <v-col class="d-flex pa-1" cols="12" sm="12">
                            <div class="pt-4">
                                <h5 class="heading text-left">{{ this.$t('contact') }}</h5>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <!-- Contact person -->
                        <v-col class="d-flex pa-1" cols="12" sm="12">
                            <v-text-field outlined hide-details="auto" dense
                                v-model="medicalInstitutionToAdd.contactPerson"
                                :rules="[v => !!v || 'Item is required']" :label="$t('contact-person')" required
                                :key="'textField7' + componentKey">
                            </v-text-field>
                        </v-col>
                        <!-- Phone number -->
                        <v-col class="d-flex pa-1" cols="6" md="6" sm="12">
                            <v-text-field outlined hide-details="auto" dense
                                v-model="medicalInstitutionToAdd.contactPhone" :rules="[v => !!v || 'Item is required']"
                                :label="$t('contact-phone')" @input="formatPhoneNumber" required
                                :key="'textField8' + componentKey">
                            </v-text-field>
                        </v-col>
                        <!-- Contact email -->
                        <v-col class="d-flex pa-1" cols="6" md="6" sm="12">
                            <v-text-field class="ml-2" outlined hide-details="auto" dense
                                v-model="medicalInstitutionToAdd.contactEmail" :rules="[v => !!v || 'Item is required']"
                                :label="$t('contact-email')" required :key="'textField9' + componentKey">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <!-- Settings label -->
                        <v-col class="d-flex pa-1" cols="12" sm="12">
                            <div class="pt-4">
                                <h5 class="heading text-left">{{ $t('settings') }}</h5>
                            </div>
                        </v-col>
                        <!-- Billing monitoring plan -->
                        <v-col cols="12" class="d-flex pa-1 my-2">
                            <v-select outlined dense hide-details v-model="selectedType" :items="billingMonitoringTypes"
                                :item-text="$i18n.locale === 'en' ? 'longDescription' : 'longDescriptionEsp'"
                                item-value="lowValue" :label="$t('billing-monitoring-type-label')"></v-select>
                        </v-col>
                    </v-row>
                    <v-row>
                        <!-- Assessments -->
                        <v-col class="d-flex pa-1" cols="12" md="6" sm="12">
                            <div class="d-flex flex-column">
                                <span class="font-weight-bold color-black">{{ $t('enable-assessments') }}</span>
                                <v-btn-toggle v-model="mentalHeath" row active-class="chips white--text" mandatory
                                    class="white">
                                    <v-btn class="tabs-class" :value="1" :input-value="mentalHeath">{{ $t("yes")
                                        }}</v-btn>
                                    <v-btn class="tabs-class" :value="0" :input-value="mentalHeath">{{ $t("no")
                                        }}</v-btn>
                                </v-btn-toggle>
                            </div>
                        </v-col>
                        <!-- Use G3002 for RTM -->
                        <v-col class="d-flex pa-1" cols="12" md="6" sm="12">
                            <div class="d-flex flex-column">
                                <span class="font-weight-bold color-black">{{ $t('enable-G3002-rtm') }}</span>
                                <v-btn-toggle v-model="G3002RTM" row active-class="chips white--text" mandatory
                                    class="white">
                                    <v-btn class="tabs-class" :value="1" :input-value="G3002RTM">{{ $t("yes") }}</v-btn>
                                    <v-btn class="tabs-class" :value="0" :input-value="G3002RTM">{{ $t("no") }}</v-btn>
                                </v-btn-toggle>

                            </div>
                        </v-col>
                    </v-row>
                    <v-row class="mt-5">
                        <v-col cols="12" class="ma-0 pa-0">
                            <v-checkbox class="ma-0 pa-0" v-model="dailyReminder" :label="$t('daily-reminder')" />
                        </v-col>
                        <v-col cols="12" class="ma-0 pa-0">
                            <v-checkbox class="ma-0 pa-0" v-model="daylyMeasurementsReportDone"
                                :label="$t('daily-measurements-report-done')" />
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
        </v-card-text>
        <v-card-actions class="fixed-card-actions">
            <v-row dense class="mx-0 px-0 mr-2">
                <v-col cols="6">
                    <v-btn @click="closeDrawer" elevation="0" class="cancel-button-style capitalize-text">
                        {{ $t('cancel') }}
                    </v-btn>
                </v-col>
                <v-col cols="6">
                    <v-btn :disabled="isSaveButtonDisabled()" @click="saveMedicalInstitution" class="save-button-style">
                        {{ $t('save') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-actions>
    </v-card>
</template>

<script>
import { closeWhite } from '@/assets';
import { mapGetters, mapState } from 'vuex';
import MedicalInstitution from '../../data/models/MedicalInstitution';
import { showSuccessAlert, showErrorAlert } from '@/utils/utilities';
import { AsYouType } from 'libphonenumber-js';

export default {
    name: 'DashboardCoreAppBar',
    components: {},
    data: () => ({
        selectedType: 0,
        mentalHeath: 0,
        G3002RTM: 0,
        closeWhite: closeWhite,
        valid: false,
        componentKey: 0,
        menu: false,
        medicalInstitutionToAdd: new MedicalInstitution(),
        validationErrors: [],
    }),
    computed: {
        ...mapGetters({
            delay: 'authentication/getDelay',
        }),
        ...mapState({
            billingMonitoringTypes: (state) => state.verifiers.billingMonitoringTypes,
        }),
        dailyReminder: {
            get () {
                return JSON.parse(this.medicalInstitutionToAdd.notificationSettings)?.dailyReportNotification.dailyReminder || false;
            },
            set (value) {
                const updateObject = {
                    dailyReportNotification: {
                        dailyReminder: value || false,
                        daylyMeasurementsReportDone: JSON.parse(this.medicalInstitutionToAdd.notificationSettings)?.dailyReportNotification.daylyMeasurementsReportDone || false,
                    },
                };
                this.medicalInstitutionToAdd.notificationSettings = JSON.stringify(updateObject);
            },
        },
        daylyMeasurementsReportDone: {
            get () {
                return JSON.parse(this.medicalInstitutionToAdd.notificationSettings)?.dailyReportNotification.daylyMeasurementsReportDone || false;
            },
            set (value) {
                const updateObject = {
                    dailyReportNotification: {
                        dailyReminder: JSON.parse(this.medicalInstitutionToAdd.notificationSettings)?.dailyReportNotification.dailyReminder || false,
                        daylyMeasurementsReportDone: value || false,
                    },
                };
                this.medicalInstitutionToAdd.notificationSettings = JSON.stringify(updateObject);
            },
        },
    },
    mounted () {
        this.getBillingMonitoringTypes();
    },
    methods: {
        async getBillingMonitoringTypes () {
            await this.$store.dispatch('verifiers/getBillingMonitoringTypes');
        },
        resetComponent () {
            // Reset firstname or any other component state as needed
            this.medicalInstitutionToAdd.institutionName = '';
            this.medicalInstitutionToAdd.description = '';
            this.medicalInstitutionToAdd.address = '';
            this.medicalInstitutionToAdd.city = '';
            this.medicalInstitutionToAdd.state = '';
            this.medicalInstitutionToAdd.zip = '';
            this.medicalInstitutionToAdd.country = '';
            this.medicalInstitutionToAdd.contactPerson = '';
            this.medicalInstitutionToAdd.contactEmail = '';
            this.medicalInstitutionToAdd.contactPhone = '+1';
            // Change the key to trigger component reset
            this.componentKey += 1;
        },
        formatPhoneNumber (val) {
            this.medicalInstitutionToAdd.contactPhone = new AsYouType().input(val);
        },
        getAllMedicalInstitutions () {
            this.$store.dispatch('medicalInstitutions/getMedicalInstitutions').then(() => {
                this.closeDrawer();
            });
        },
        async saveMedicalInstitution () {
            const waitAddressValidation = await this.checkAndFixLocationDetails();
            if (!waitAddressValidation) {
                // this.validationErrors.push('address');
                // go on with the given addres data
            }
            this.medicalInstitutionToAdd.contactPhone = new AsYouType().input(this.medicalInstitutionToAdd.contactPhone);
            var wellnessFlagDefault = false;
            var useG3002ForRTM = false;

            if (this.mentalHeath === 1) {
                wellnessFlagDefault = true;
            }
            if (this.G3002RTM === 1) {
                useG3002ForRTM = true;
            }

            if (this.$refs.form.validate()) {
                const body = {
                    institutionName: this.medicalInstitutionToAdd.institutionName,
                    description: this.medicalInstitutionToAdd.description,
                    contactPerson: this.medicalInstitutionToAdd.contactPerson,
                    contactPhone: this.medicalInstitutionToAdd.contactPhone,
                    address: this.medicalInstitutionToAdd.address,
                    zip: this.medicalInstitutionToAdd.zip,
                    city: this.medicalInstitutionToAdd.city,
                    state: this.medicalInstitutionToAdd.state,
                    country: this.medicalInstitutionToAdd.country,
                    addressLatitude: this.medicalInstitutionToAdd.addressLatitude,
                    addressLongitude: this.medicalInstitutionToAdd.addressLongitude,
                    contactEmail: this.medicalInstitutionToAdd.contactEmail,
                    mediaServerData: this.medicalInstitutionToAdd.mediaServerData,
                    WellnessFlagDefault: wellnessFlagDefault,
                    UseG3002ForRTM: useG3002ForRTM,
                    billingMonitoringPlan: this.selectedType,
                    notificationSettings: this.medicalInstitutionToAdd.notificationSettings,
                };

                await this.$store.dispatch('medicalInstitutions/createMedicalInstitution', body).then((res) => {
                    if (res) {
                        showSuccessAlert(this.$t('successfully-created-organization'));
                        this.getAllMedicalInstitutions(); // reload the list of organizations
                    } else {
                        showErrorAlert(this.$t('failed-operation'));
                    }
                });
                this.resetComponent();
            } else {
                this.$refs.form.validate();
            }
            this.mentalHeath = 0;
        },
        save (date) {
            this.$refs.menu.save(date);
        },
        closeDrawer () {
            this.valid = false;
            this.medicalInstitutionToAdd = new MedicalInstitution();
            this.resetComponent();
            this.$store.commit('SET_DETAILS_DRAWER', false);
            this.mentalHeath = 0;
        },
        async checkAndFixLocationDetails () {
            try {
                const h = this.medicalInstitutionToAdd;
                if (h.address !== '') {
                    const addressForValidation = h.address;
                    const geoLocation = await this.$store.dispatch('googleAPI/getGeoLocation', addressForValidation,
                    );

                    if (!geoLocation || !geoLocation.address_components || !geoLocation.geometry) {
                        h.addressLatitude = 0.01;
                        h.addressLongitude = 0.01;
                        return false;
                    }

                    const components = geoLocation.address_components;
                    const getComponent = (type) => {
                        const found = components.find(c => c.types.includes(type));
                        return found ? found.long_name : 'N/A';
                    };

                    // Extract and set location info
                    const lat = geoLocation.geometry.location.lat || 0.01;
                    const lng = geoLocation.geometry.location.lng || 0.01;

                    h.addressLatitude = lat;
                    h.addressLongitude = lng;
                    h.address = geoLocation.formatted_address || h.address;
                    h.city = getComponent('locality') || getComponent('sublocality') || getComponent('administrative_area_level_2') || 'N/A';
                    h.state = getComponent('administrative_area_level_1') || 'N/A';
                    h.country = getComponent('country') || 'N/A';
                    h.zip = getComponent('postal_code') || 'N/A';

                    // Now call Time Zone API
                    const timestamp = Math.floor(Date.now() / 1000); // current time in seconds
                    const timeZoneResponse = await fetch(`https://maps.googleapis.com/maps/api/timezone/json?location=${lat},${lng}&timestamp=${timestamp}&key=${process.env.VUE_APP_GOOGLEMAPAPIKEY}`);
                    const timeZoneData = await timeZoneResponse.json();

                    if (timeZoneData.status === 'OK') {
                        h.timeZoneId = timeZoneData.timeZoneId; // e.g., "Europe/Skopje"
                        h.timeZoneName = timeZoneData.timeZoneName; // e.g., "Central European Summer Time"
                        h.rawOffset = timeZoneData.rawOffset; // base offset in seconds
                        h.dstOffset = timeZoneData.dstOffset; // daylight savings offset in seconds
                        h.hospitalTimeZone = timeZoneData.timeZoneId;
                    } else {
                        // If timezone fetch failed, set default or null
                        h.timeZoneId = 'N/A';
                        h.timeZoneName = 'N/A';
                        h.rawOffset = 0;
                        h.dstOffset = 0;
                        h.hospitalTimeZone = this.defaultTimeZone;
                    }
                } else {
                    h.addressLatitude = 0.01;
                    h.addressLongitude = 0.01;
                    return false;
                }
            } catch (error) {
                return false;
            }
        },

        isSaveButtonDisabled () {
            const check = (
                !this.medicalInstitutionToAdd.institutionName ||
                !this.medicalInstitutionToAdd.address ||
                !this.medicalInstitutionToAdd.contactPerson ||
                this.medicalInstitutionToAdd.contactPhone.length < 10 ||
                !this.medicalInstitutionToAdd.contactEmail
            );
            return check;
        },
    },
};
</script>
